import BillingInfoBlock from '@anm/components/subscription/billing-info/BillingInfoBlock';
import { useCallback, FC } from 'react';
import { useSelector } from 'react-redux';
import { BillingAddress } from 'user';

import useUpdateUserHandler from '../../../hooks/user/useUpdateUserHandler';
import { userSelectors } from '../../../store/modules/user';

const UserBillingInfo: FC = () => {
  const updateUser = useUpdateUserHandler();
  const billingAddress = useSelector(userSelectors.selectUserBillingAddress);
  const updateUserBillingAddress = useCallback(
    (newBillingAddress: BillingAddress) => {
      updateUser({
        meta: { billingAddress: { ...billingAddress, ...newBillingAddress } }
      });
    },
    [billingAddress]
  );

  return (
    <BillingInfoBlock
      initialValues={billingAddress}
      onAutoSave={updateUserBillingAddress}
    />
  );
};

export default UserBillingInfo;
